<template>
  <div class="TranProgramActivityReminder-view-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-button class="btn ml-3" type="button" @click="returnPage">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
          </span>
          Trở về trước
        </b-button>
        <b-button
          class="btn btn-inactive ml-3"
          type="button"
          v-if="tranProgramActivityReminderData.isActive && isDeletePermission"
          @click="handleInactive(tranProgramActivityReminderData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Inactive
        </b-button>
        <b-button
          class="btn btn-active ml-3"
          type="button"
          v-if="!tranProgramActivityReminderData.isActive && isDeletePermission"
          @click="handleInactive(tranProgramActivityReminderData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Active
        </b-button>
        <b-button
          class="btn btn-success ml-3"
          type="button"
          v-if="isDeletePermission"
          @click.stop="handleUpdate(tranProgramActivityReminderData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/edit-2.svg" />
          </span>
          Chỉnh sửa
        </b-button>
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="TranProgramActivityReminder-view-page__body mb-6 mt-6">
        
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">Id:</div>
                    <div>
                        {{ tranProgramActivityReminderData.id }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">Code:</div>
                    <div>
                        {{ tranProgramActivityReminderData.code }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">IsDeleted:</div>
                    <div>
                        {{ tranProgramActivityReminderData.isDeleted }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">CreateDatetime:</div>
                    <div>
                        {{ tranProgramActivityReminderData.createDatetime }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">UpdateDatetime:</div>
                    <div>
                        {{ tranProgramActivityReminderData.updateDatetime }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">CreatorId:</div>
                    <div>
                        {{ tranProgramActivityReminderData.creatorId }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">UpdaterId:</div>
                    <div>
                        {{ tranProgramActivityReminderData.updaterId }}
                    </div>
            </b-col>
            <b-col>
                
            </b-col>
            <b-col>
                
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">ReminderTime:</div>
                    <div>
                        {{ tranProgramActivityReminderData.reminderTime }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">ReminderAtranDayNum:</div>
                    <div>
                        {{ tranProgramActivityReminderData.reminderAtranDayNum }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">ReminderAtranTime:</div>
                    <div>
                        {{ tranProgramActivityReminderData.reminderAtranTime }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">ReminderContain:</div>
                    <div>
                        {{ tranProgramActivityReminderData.reminderContain }}
                    </div>
            </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      isFirstLoad: false,
      TranProgramActivityReminderData: {},
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    isDeletePermission() {
      let roles = this.currentUser?.roles;
      if (roles && roles.length) {
        return roles.includes('Admin');
      } else {
        return false;
      }
    },
  },
  methods: {
    returnPage() {
      this.$router.push({
        name: 'tranProgramActivityReminder_list',
      });
    },
    handleUpdate(item) {
      this.$router.push({
        name: 'tranProgramActivityReminder_detail',
        params: {
          form_type: 'edit',
          id: item.id,
        },
      });
    },
    handleInactive(item) {
      let text = item.isActive ? 'Inactive' : 'Active';
      let btn = item.isActive ? 'btn-inactive' : 'btn-active';
      this.$swal({
        title: '',
        text: `Bạn có chắc muốn ${text} app user ${item.id} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `${text}`,
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.inactiveItem(item)
              .then(() => {
                this.loadTranProgramActivityReminderData();
                this.$swal(
                  'Thành công!',
                  'Chúc mừng, bạn đã cập nhật thông tin TranProgramActivityReminder thành công!',
                  'success',
                );
              })
              .catch(() => {
                this.$swal('Lỗi!', 'Đã có lỗi xảy ra.', 'error');
              });
          }
        }.bind(this),
      );
    },
    async inactiveItem(item) {
      this.loading = true;
      try {
        let payload = new FormData();
        payload.append('id', item.id);
        payload.append('active', !item.isActive);
        await this.$api.put(`TranProgramActivityReminder`, payload);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async loadTranProgramActivityReminderData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`TranProgramActivityReminder/${id}`);
        this.tranProgramActivityReminderData = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadTranProgramActivityReminderData();
  },
};
</script>
